import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewCILModal = ({ show, handleClose, cil }) => {
    if (!cil) return null;

    // Get user info from localStorage, if needed for other logic
    const user = JSON.parse(localStorage.getItem('user'));

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View CIL Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>CIL No. :</strong> {cil.id}
                </div>

                <div className="mb-3">
                    <strong>Client Name:</strong> {cil.clientName}
                </div>
                <div className="mb-3">
                    <strong>Client Number:</strong> {cil.clientNumber}
                </div>
                <div className="mb-3">
                    <strong>Total Deal Value:</strong> {cil.dealValue ? Number(cil.dealValue).toLocaleString() : 'N/A'}
                </div>

                {/* Only show actual commission value if user type is admin */}
                {user?.type === 'admin' && (
                    <div className="mb-3">
                        <strong>Actual Commission Value:</strong> {cil.actualAmount ? Number(cil.actualAmount).toLocaleString() : 'N/A'}
                    </div>
                )}

                <div className="mb-3">
                    <strong>Broker Name:</strong> {cil.broker?.name}
                </div>
                <div className="mb-3">
                    <strong>Broker Number:</strong> {cil.broker?.mobile}
                </div>
                <div className="mb-3">
                    <strong>Developer Sales Name:</strong> {cil.developer_sales?.name}
                </div>
                <div className="mb-3">
                    <strong>Project:</strong> {cil.project?.name}
                </div>
       {/*incentive */}
{cil.project?.incentive && (
  <>
    <div className="mb-3">
      <strong>Incentive Amount:</strong> {cil.project?.incentive ? Number(cil.project.incentive).toLocaleString() : 'N/A'}
    </div>
    <div className="mb-3">
      <strong>Incentive Type:</strong> {cil.project?.incentiveType}
    </div>
    <div className="mb-3">
      <strong>Incentive Start Date:</strong> {cil.project?.incentiveStartDate}
    </div>
    <div className="mb-3">
      <strong>Incentive End Date:</strong> {cil.project?.incentiveEndDate}
    </div>
  </>
)}



                <div className="mb-3">
                    <strong>Unit Code:</strong> {cil.unit?.unitCode}
                </div>
                <div className="mb-3">
                    <strong>Unit Type:</strong> {cil.typeOfUnit}
                </div>

                {/* Only show contract image if user type is admin and cil.document exists */}
                {user?.type === 'admin' && cil.document && (
                    <div className="mb-3">
                        <strong>Contract Image:</strong>{' '}
                        <a
                            href={cil.document}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#487fff', textDecoration: 'underline', cursor: 'pointer' }}
                        >
                            View Document
                        </a>
                    </div>
                )}

                <div className="mb-3">
                    <strong>Expiration Date:</strong> {cil.expirationDate}
                </div>

                {/* Show Status if user is admin */}
                {user?.type === 'admin' && (
                    <div className="mb-3">
                        <strong>Status:</strong> {cil.status}
                    </div>
                )}

                {/* Always show Rejection Reason if present (for all user types) */}
                {cil.reason && (
                    <div className="mb-3">
                        <strong>Rejection Reason:</strong> {cil.reason}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewCILModal;
